import React, { useState } from "react";
import { Snackbar, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const InfoBar = ({ Information, flag, popupState, setPopupState }) => {
  const handleTableSaveClose = () => {
    setPopupState(false);
  };

  let borderStyle;

  if (flag === null) {
    borderStyle = "1px solid orange";
  } else if (flag) {
    borderStyle = "1px solid green";
  } else {
    borderStyle = "1px solid red";
  }

  const snackbarStyles = {
    backgroundColor: flag ? "green" : "white",
    color: flag ? "white" : "red",
    border: borderStyle,
    transition: "border-bottom 3s linear",
    position: "relative",
  };

  let textColor;
  if (flag === null) {
    textColor = "orange";
  } else if (flag) {
    textColor = "white";
  } else {
    textColor = "red";
  }
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={popupState}
        onClose={handleTableSaveClose}
        message={
          <span
            style={{
              color: textColor,
              fontWeight: "normal",
            }}
          >
            {Information}
          </span>
        }
        autoHideDuration={5000}
        key="topright"
        ContentProps={{
          sx: snackbarStyles,
        }}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleTableSaveClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </>
  );
};

export default InfoBar;
